import { canv } from "@/canv/global.js";
import { getTarget } from "@/canv/utils";
import { generateColor } from "@/helpers/generateColor";
import { getInitials } from "@/helpers/getInitials";
import type { MultiUser } from "@/multiManager";

export class UsersWindow {
    show() {
        const usersWindowWrapper = document.createElement("div");
        usersWindowWrapper.classList.add("usersWindowWrapper");

        document.body.append(usersWindowWrapper);

        usersWindowWrapper.innerHTML = this.getWindow();

        this.reFillUsers();
        this.initUsers();
    }

    close() {
        const usersWindow = document.getElementsByClassName("usersWindowWrapper")[0];
        if (usersWindow != undefined) {
            usersWindow.outerHTML = "";
        }
    }

    reFillUsers() {
        const otherUsers = canv.multiManager.multiUsersMap;
        const users = Array.from(otherUsers.values())
            .map((user) => {
                const isCurrentUser = canv.getInitDataProp("userToken") === user.token;
                return this.getUserTemplate(
                    user.name,
                    generateColor(isCurrentUser ? user.sessionUID : user.token || user.sessionUID),
                    user.sessionUID,
                );
            })
            .join("");

        const usersWindowUsersCount = document.querySelector(".usersWindowUsersCount");
        if (usersWindowUsersCount) {
            usersWindowUsersCount.innerHTML = `Пользователи: ${otherUsers.size + 1}`;
        }

        const usersWindowOtherUsers = document.querySelector(".usersWindowOtherUsers");
        if (usersWindowOtherUsers) {
            usersWindowOtherUsers.innerHTML = users;
            const elements = document.querySelectorAll(".hiddenUserWindow");
            const styleText = users.length > 1 ? "block" : "none";
            elements.forEach((element) => {
                (element as HTMLElement).style.setProperty("display", styleText);
            });
        }
    }

    initUsers() {
        // wrapper
        const markUsersWindowWrapper = document.getElementsByClassName("usersWindowWrapper")[0];
        markUsersWindowWrapper.addEventListener("mousedown", this.wrapperClick.bind(this), false);

        const users = document.getElementsByClassName("usersWindowItem");

        for (let i = 1; i < users.length; i++) {
            users[i].addEventListener("mousedown", this.userClick.bind(this), false);
        }

        const callUsersBtn = document.getElementsByClassName("usersWindowCallUsersBtn")[0];
        callUsersBtn.addEventListener("mousedown", this.callUsersClick.bind(this), false);
    }

    userClick(e: Event) {
        const monet = getTarget(e, "usersWindowItem");
        const sessionUID = monet.getAttribute("sessionUID");

        if (sessionUID !== canv.multiManager.viewSubscribeUID) {
            const sortedMultiUsers: Map<string, MultiUser> = new Map();

            for (const multiUser of canv.multiManager.multiUsersMap.values()) {
                if (multiUser.sessionUID === sessionUID) {
                    sortedMultiUsers.delete(sessionUID);
                } else {
                    sortedMultiUsers.set(sessionUID, multiUser);
                }
            }

            canv.multiManager.multiUsersMap = sortedMultiUsers;
        }

        canv.multiManager.tryViewSubscribe(sessionUID);
    }

    wrapperClick(e: Event) {
        const tryInner = getTarget(e, "usersWindow");
        if (tryInner === null) {
            this.close();
        }
    }

    callUsersClick() {
        if (canv.multiManager.multiUsersMap.size) {
            canv.intercom.fastMessage("cursor_follow_invite", {
                sessionUID: canv.sessionUID,
            });
            this.close();
        }
    }

    // Templates

    getUserTemplate(name: string, color: string, sessionUID?: string) {
        let selectorOn = "";
        if (
            canv.multiManager.viewSubscribeUID != "" &&
            canv.multiManager.viewSubscribeUID == sessionUID
        ) {
            selectorOn = " usersWindowItemSelectorOn";
        }

        const me = sessionUID ? "" : " usersWindowItemMe";

        return `
            <div class="usersWindowItem usersWindowItemSelector${me}${selectorOn}" sessionUID=${sessionUID}>
                <div class="usersWindowItemLogo" style="background-color: ${color}"><p>${getInitials(name)}</p></div>
                <div class="usersWindowItemName">${name}</div>
            </div>
        `;
    }

    getWindow() {
        const me = this.getUserTemplate(
            canv.getInitDataProp("userName"),
            generateColor(canv.getInitDataProp("userToken")),
        );

        return `
            <div class="usersWindow scrollable">
                <div class="usersWindowUsersCount"></div>
                <div class="divider"></div>
                <div class="usersWindowMeBlockContainer">
                    ${me}
                    <button class="usersWindowCallUsersBtn hiddenUserWindow">
                        Позвать всех к себе
                    </button>
                </div>
                <div class="divider hiddenUserWindow"></div>
                <div class="usersWindowOtherUsers"></div>
            </div>
        `;
    }
}
